import { environment, unleashConfig } from '@/config';

function customFetch(url: string, init: any) {
  init = init || {};
  init.headers = init.headers || {};
  init.headers['X-UI-AppName'] = 'Comet';
  return fetch(url, init);
}

export default {
  url: unleashConfig.url,
  appName: unleashConfig.appName,
  fetch: customFetch,
  clientKey: unleashConfig.clientKey,
  disableMetrics: true,
  usePOSTrequests: true,
  environment: environment === 'production' ? 'production' : 'development'
};
